
let data;
export default data =  [
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1860.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1861.jpg",
        info:{
                Title:"90/90 Hamstring Stretch",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Stretching",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1856.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1857.jpg",
        info:{
                Title:"All Fours Quad Stretch",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Stretching",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/3568.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/3569.jpg",
        info:{
                Title:"Alternating Diagonal Leg Bound",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Stretching",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/860.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/861.jpg",
        info:{
                Title:"Band Squat",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Strength",
                equip:"Equipment : Bands"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4884.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4885.jpg",
        info:{
                Title:"Barbell 1/2 Squat",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4808.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4809.jpg",
        info:{
                Title:"Barbell 1/4 Squat",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1872.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1873.jpg",
        info:{
                Title:"Barbell Bench Squat",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1876.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1877.jpg",
        info:{
                Title:"Barbell Clean",
                group:"Main Muscle Group : Upper Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    

]